import { useTranslations } from "next-intl";
import { useFormatDate } from "@hooks/use-format-date";
import closetStates from "@utils/constants/closetStates";

function ClosetHeader({ closet }) {
  const t = useTranslations("closets");
  const formatDate = useFormatDate();

  const closetState = closet?.state;

  if (closetState === closetStates.readyToChange) return null;

  return (
    <div>
      <p className="font-weight-bold mb-0">{formatDate(closet?.ready_to_pack_at)}</p>
      <p className="mb-3">
        {t.rich(`state.${closetState}.status_title`, {
          span: (chunks) => <span className="text-gray">{chunks}</span>,
        })}
      </p>
    </div>
  );
}

export default ClosetHeader;
